import { Component, OnInit, inject } from '@angular/core';
import { VariablesGlobalesService } from 'src/app/services/variables-globales.service';
import { CarritoComponent } from '../carrito/carrito.component';
import { InfoConexionComponent } from '../info-conexion/info-conexion.component';
import { MeteorologiaComponent } from '../meteorologia/meteorologia.component';
import { AMResultados } from 'src/app/Models/AMResultados';
import { globalConf } from 'src/GlobalConf';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { IonChip, IonCol, IonGrid, IonHeader, IonLabel, IonRow , IonIcon, IonBadge, ModalController, Platform, PopoverController, ToastController} from "@ionic/angular/standalone";
import { NgClass } from '@angular/common';
import { IconoCieloPipe } from 'src/app/pipes/iconoCielo.pipe';
import { addIcons} from 'ionicons';
import { ellipse, clipboardOutline, clipboard , trash, close} from 'ionicons/icons';

@Component({
    selector: 'app-barra-superior',
    templateUrl: './barra-superior.component.html',
    styleUrls: ['./barra-superior.component.scss'],
    standalone: true,
    providers: [],
    imports : [NgClass, IonHeader, IonGrid, IonRow, IonCol , IonBadge  , IconoCieloPipe, IonChip, IonIcon, IonLabel ]
})

export class BarraSuperiorComponent implements OnInit {
  variablesGlobales = inject(VariablesGlobalesService);
  popoverController = inject(PopoverController);
  modalController = inject(ModalController);
  private http = inject(HttpClient);
  private variables = inject(VariablesGlobalesService);
  private toastController = inject(ToastController);
  translate = inject(TranslateService);
  platform = inject(Platform);


  public nombreLocalidad: string;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    addIcons({ellipse , clipboardOutline, clipboard, trash, close});
   }

  ngOnInit() {}

  animacionCarrito(){
    const icon = document.getElementById('icon');
    icon.classList.add('bounce');

    setTimeout(() => {
      icon.classList.remove('bounce');
    }, 2000);
  }

  async modalTiempo() {
    const modal = await this.modalController.create({
      component: MeteorologiaComponent,
      cssClass: 'modalTiempo'
    });

    return await modal.present();
  }

  async modalConexion() {
    const autorizacionBase64 = btoa(
      globalConf.user_empresa + ':' + globalConf.pwd_empresa
    );

    const cabecera = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', 'Basic ' + autorizacionBase64);
      this.http.get(globalConf.url_api_erp + globalConf.path_test_empresas + this.variables.empresaActual.GUID_Registro, { headers: cabecera }).toPromise()
      .then((conexion: AMResultados) => {
        this.variablesGlobales.conexionBaseDeDatos = conexion.Ok;
        console.log('***home.await this.amservicio.obtenerTestAMPresencia() despues ', this.variablesGlobales.conexionBaseDeDatos);
      })
      .catch(error => {
        this.variablesGlobales.conexionBaseDeDatos = false;
        console.log('***home.await this.amservicio.obtenerTestAMPresencia() problema  ' + this.variablesGlobales.conexionBaseDeDatos + ' ' + error);
      });

    const modal = await this.modalController.create({
      component: InfoConexionComponent,
      cssClass: 'modalConexion'
    });

    return await modal.present();
  }

  async mostrarCarrito(){
    if(this.variablesGlobales.documentoEnCurso){
      console.log('this.variablesGlobales.documentoActual: ',this.variablesGlobales.documentoActual);
      if(this.variablesGlobales.plataforma == 'movil'){
        const modal = await this.modalController.create({
          component: CarritoComponent,
          componentProps: {
            documentoApp: this.variablesGlobales.documentoActual
          },
          mode: 'ios',
          breakpoints:[0,1],
          initialBreakpoint: 1
        });
        return await modal.present();
      } else {
        const modal = await this.modalController.create({
          component: CarritoComponent,
          cssClass: 'modalCarrito',

          componentProps: {
            documentoApp: this.variablesGlobales.documentoActual
          },
          mode: 'ios'
        });
        return await modal.present();
      }

    }else{
      this.translate.get('toast.noHayDocumentoEnCurso').subscribe(async (toastStr:string)=> {
        const toast = await this.toastController.create({
          message: toastStr,
          duration: 1500,
        });
        await toast.present();
      })
    }

  }
}
